<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('orderList.type') }}:</span>
        <el-radio-group size="medium" v-model="type">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ club_type(0) }}</el-radio>
          <el-radio :label="1">{{ club_type(1) }}</el-radio>
          <el-radio :label="2">{{ activity_type('1') }}</el-radio>
          <el-radio :label="3">{{ activity_type('2') }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('orderList.pay_method') }}:</span>
        <el-radio-group size="medium" v-model="filter.pay_method">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio label="card">{{ pay_method('card') }}</el-radio>
          <el-radio label="trans">{{ pay_method('trans') }}</el-radio>
          <el-radio label="phone">{{ pay_method('phone') }}</el-radio>
          <el-radio label="coupon">{{ pay_method('coupon') }}</el-radio>
          <el-radio label="naverpay">{{ pay_method('naverpay') }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('orderList.status') }}:</span>
        <el-radio-group size="medium" v-model="filter.status">
          <el-radio label>{{ $t('all') }}</el-radio>
          <!-- <el-radio :label="0">{{ status(0) }}</el-radio> -->
          <el-radio :label="1">{{ status(1) }}</el-radio>
          <el-radio :label="2">{{ status(2) }}</el-radio>
          <el-radio :label="3">{{ status(3) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('orderList.pay_time') }}:</span>
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="right"
          :range-separator="$t('to')"
          :start-placeholder="$t('start_date')"
          :end-placeholder="$t('end_date')"
        >
        </el-date-picker>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div></div>
        <el-button type="primary" @click="outExe">{{ $t('outExe') }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:title="slotProps">
          <div>
            {{
              slotProps.callback.row.type === 1
                ? slotProps.callback.row.activity_title
                : slotProps.callback.row.club_title
            }}
          </div>
        </template>
        <template v-slot:type="slotProps">
          <div>
            {{
              slotProps.callback.row.type === 1
                ? activity_type(slotProps.callback.row.activity_type)
                : club_type(slotProps.callback.row.club_type)
            }}
          </div>
        </template>
        <template v-slot:pay_method="slotProps">
          <div>
            {{ pay_method(slotProps.callback.row.pay_method) }}
          </div>
        </template>
        <template v-slot:quantity="slotProps">
          <div>
            {{
              slotProps.callback.row.quantity
                ? slotProps.callback.row.quantity
                : 1
            }}
          </div>
        </template>
        <template v-slot:pay_time="slotProps">
          <div>
            {{ slotProps.callback.row.pay_time | currentTime }}
          </div>
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">
            {{ status(slotProps.callback.row.status) }}
          </el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').check"
            placement="top"
          >
            <el-button
              @click="handleClick('check', slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              @click="del(slotProps.callback.row.id)"
              type="danger"
              size="mini"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip> -->
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat';
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import { orderList, orderDetail } from '@/api/api';
export default {
  name: 'orderList',
  mixins: [mixin_list(orderList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      time,
      type: '',
      filter: {
        search: '',
        status: '',
        pay_method: '',
        club__type: '',
        activity__type: '',
        start_time: '',
        end_time: '',
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('orderList.real_name'),
          sortable: true,
          prop: 'real_name',
        },
        {
          label: this.$t('orderList.merchant_uid'),
          sortable: true,
          prop: 'merchant_uid',
        },
        {
          label: this.$t('orderList.title'),
          sortable: true,
          prop: 'title',
          slot: 'title',
        },
        {
          label: this.$t('orderList.type'),
          sortable: true,
          prop: 'type',
          slot: 'type',
        },
        {
          label: this.$t('orderList.pay_method'),
          sortable: true,
          prop: 'pay_method',
          slot: 'pay_method',
        },
        {
          label: this.$t('orderList.price'),
          sortable: true,
          prop: 'price',
          width: 100,
        },
        {
          label: this.$t('orderList.discount'),
          sortable: true,
          prop: 'discount',
        },
        {
          label: this.$t('orderList.pay_amount'),
          sortable: true,
          prop: 'pay_amount',
        },
        {
          label: this.$t('orderList.count'),
          sortable: false,
          prop: 'quantity',
          slot: 'quantity',
        },
        {
          label: this.$t('orderList.pay_time'),
          sortable: true,
          prop: 'pay_time',
          slot: 'pay_time',
        },
        {
          label: this.$t('orderList.status'),
          sortable: true,
          prop: 'status',
          slot: 'status',
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 100,
          slot: 'operation',
        },
      ],
      dateValue: '',
    };
  },
  watch: {
    dateValue() {
      if (this.dateValue === null) {
        this.filter.start_time = '';
        this.filter.end_time = '';
        return;
      }
      this.filter.start_time = this.dateValue[0].getTime() / 1000;
      this.filter.end_time = this.dateValue[1].getTime() / 1000 + 24 * 60 * 60;
    },
    type(value) {
      switch (value) {
        case '':
          this.filter.club__type = '';
          this.filter.activity__type = '';
          return;
        case 0:
          this.filter.club__type = 0;
          this.filter.activity__type = '';
          return;
        case 1:
          this.filter.club__type = 1;
          this.filter.activity__type = '';
          return;
        case 2:
          this.filter.club__type = '';
          this.filter.activity__type = 1;
          return;
        case 3:
          this.filter.club__type = '';
          this.filter.activity__type = 2;
          return;
      }
    },
  },
  filters: {
    currentTime(val) {
      return time.currentTime(val * 1000);
    },
  },
  methods: {
    pay_method(pay_method) {
      switch (pay_method) {
        case 'card':
          return this.$t('orderList.pay_method0');
        case 'trans':
          return this.$t('orderList.pay_method1');
        case 'phone':
          return this.$t('orderList.pay_method2');
        case 'coupon':
          return this.$t('orderList.pay_method3');
        case 'naverpay':
          return this.$t('orderList.pay_method4');
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('orderList.status0');
        case 1:
          return this.$t('orderList.status1');
        case 2:
          return this.$t('orderList.status2');
        case 3:
          return this.$t('orderList.status3');
        case 5:
          return this.$t('orderList.status5');
      }
    },
    statusTag(status) {
      switch (status) {
        case 0:
          return 'warning';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        case 3:
          return 'primary';
        case 5:
          return 'warning';
      }
    },
    club_type(club_type) {
      switch (club_type) {
        case 0:
          return this.$t('orderList.club_type0');
        case 1:
          return this.$t('orderList.club_type1');
      }
    },
    activity_type(activity_type) {
      switch (activity_type) {
        case '1':
          return this.$t('orderList.activity_type2');
        case '2':
          return this.$t('orderList.activity_type1');
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case 'check':
          this.$router.push(`/orderManagement/orderList/detail?id=${data.id}`);
          break;
      }
    },
    // async del(id) {
    //   this.$confirm(this.$t('carouselManagement').sureDeleteCarousel, this.$t('tips'), {
    //     confirmButtonText: this.$t('btnTips').submit,
    //     cancelButtonText: this.$t('btnTips').cancel,
    //     type: 'warning'
    //   }).then(async () => {
    //     let res = await carouselDelete(id)
    //     this.get_list()
    //   }).catch({
    //   })
    // },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 100px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}
</style>
